/* eslint-disable max-len */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Colors from './Colors';
import {
  updateColorSortSelection,
  toggleMobileSortDrawer as toggleMobileSortDrawerActionCreator,
} from '../../../actions/sortActions';
import { setSelectedColor, setSelectedColorFilter } from '../../../actions/colorActions';
import {
  setUserHasChangedColor,
  updatePlaConfiguredPrice,
} from '../../../actions/plaConfigurations';
import { Utils } from '../../../utils/urlUtils';
import { SET_CURRENT_SKU } from '../../../actions/actionTypes';
import {
  setSearchSortChange,
  setSearchColorChange,
  setSearchTextChange,
} from '../../../actions/analytics';

import '../../../index.global.scss';

const mapStateToProps = (state, ownProps) => {
  const {
    countertops: {
      surfaces,
      selectedColor,
      selectedColorSort,
      selectedColorFilters,
      mobileSideDrawerOpen,
      allSurfaceColors,
      selectedThickness,
    },
    products: { isSamplesFulfilled, currentColorSwatches, currentOmsId },
    plaConfiguration: { plaColor, plaConfiguredPrice },
  } = state;

  const { sampleOmsId, productId } = ownProps;

  const colorSwatches = currentColorSwatches[productId] || [];

  let colors =
    colorSwatches.some((xx) => xx.price !== undefined && xx.price > 0) && isSamplesFulfilled
      ? colorSwatches
      : [];

  if (Utils.hasPlaGuid() && plaConfiguredPrice) {
    const colorsWithZeroConfigurablePrice = plaConfiguredPrice.ChoiceDeltas.filter(
      (choice) => choice.Price === 0 || choice.Delta === 0
    );
    colors = colors.filter(
      (color) => !colorsWithZeroConfigurablePrice.some((choice) => choice.ChoiceId === color.id)
    );
  }

  const colorsWithBrand = colors.map((color) => {
    const surfaceColor = allSurfaceColors.find((sc) => sc.optionId === color.externalId);
    return {
      ...color,
      brand: surfaceColor?.brand,
      metaDataItems: surfaceColor?.metaDataItems ?? color.metaDataItems ?? null,
    };
  });

  return {
    surfaces,
    colors: colorsWithBrand,
    selectedColorSort,
    selectedColor,
    selectedColorFilters,
    sampleOmsId,
    plaColor,
    sideDrawerIsOpen: mobileSideDrawerOpen,
    currentOmsId,
    allSurfaceColors,
    selectedThickness,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSelectedColor,
      updateSelectedColorSort: (selectedColorSort) =>
        dispatch(updateColorSortSelection(selectedColorSort)),
      toggleMobileSortDrawer: () => dispatch(toggleMobileSortDrawerActionCreator()),
      updateColorFilters: (selectedColorFilters) =>
        dispatch(setSelectedColorFilter(selectedColorFilters)),
      onUserHasChangedColor: (color, userHasChangedColor) =>
        dispatch(setUserHasChangedColor(color, userHasChangedColor)),
      startUpdatePlaConfiguredPrice: (color) => dispatch(updatePlaConfiguredPrice(color)),
      updateCurrentSku: (selectedThickness, sku) =>
        dispatch({
          type: SET_CURRENT_SKU,
          sku,
          height: selectedThickness,
        }),
      onSetSearchSortChange: (selectedColorSort) =>
        dispatch(setSearchSortChange({ selectedColorSort })),
      onSetSearchTextChange: (
        colors,
        selectedColorFilters,
        selectedColorSort,
        searchString,
        surfaces
      ) =>
        dispatch(
          setSearchTextChange({
            colors,
            selectedColorFilters,
            selectedColorSort,
            searchString,
            surfaces,
          })
        ),
      onSetSearchColorChange: (
        colors,
        selectedColorFilters,
        selectedColorSort,
        searchString,
        surfaces
      ) =>
        dispatch(
          setSearchColorChange({
            colors,
            selectedColorFilters,
            selectedColorSort,
            searchString,
            surfaces,
          })
        ),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Colors);
